/* HOTHANNI Effekte (Codext): Konfetti + Toast beim In-den-Warenkorb-Legen */
(() => {
  if (window.__hhFx) return; window.__hhFx = true;
  const FREE_SHIPPING = 4900; // Cent
  const COLORS = ['#ff4fd8', '#d9ffab', '#7b3fe4', '#ffffff', '#ff9de9'];
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const Z = 2147483000;
  let shapes = null;
  const money = (c) => (c / 100).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });
  const esc = (s) => String(s || '').replace(/[&<>"']/g, (m) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m]));

  const getShapes = () => {
    if (shapes !== null) return shapes;
    shapes = [];
    try { if (window.confetti && confetti.shapeFromText) shapes = ['💖', '💋', '✨'].map((t) => confetti.shapeFromText({ text: t, scalar: 2 })); } catch (e) { shapes = []; }
    return shapes;
  };

  const burst = (x, y, big) => {
    if (reduce || !window.confetti) return;
    const origin = { x: x / window.innerWidth, y: y / window.innerHeight };
    confetti({ particleCount: big ? 160 : 90, spread: big ? 110 : 75, startVelocity: big ? 48 : 38, origin, colors: COLORS, ticks: 230, zIndex: Z, disableForReducedMotion: true });
    const s = getShapes();
    if (s.length) confetti({ particleCount: big ? 36 : 20, spread: 100, startVelocity: 32, origin, shapes: s, scalar: 2, ticks: 280, zIndex: Z, flat: true, disableForReducedMotion: true });
    setTimeout(() => {
      confetti({ particleCount: 55, angle: 60, spread: 60, origin: { x: 0, y: 0.8 }, colors: COLORS, zIndex: Z, disableForReducedMotion: true });
      confetti({ particleCount: 55, angle: 120, spread: 60, origin: { x: 1, y: 0.8 }, colors: COLORS, zIndex: Z, disableForReducedMotion: true });
    }, 200);
  };

  const bumpCart = () => {
    document.querySelectorAll('.header a[href$="/cart"], .header [aria-controls="cart-drawer"]').forEach((el) => {
      el.classList.remove('hh-bump'); void el.offsetWidth; el.classList.add('hh-bump');
    });
  };

  let toastEl = null, toastTimer = null;
  const toast = (item, cart) => {
    if (toastEl) toastEl.remove();
    clearTimeout(toastTimer);
    const total = cart && typeof cart.total_price === 'number' ? cart.total_price : 0;
    const missing = Math.max(0, FREE_SHIPPING - total);
    const pct = Math.min(100, Math.round((total / FREE_SHIPPING) * 100));
    const img = item && (item.featured_image && item.featured_image.url || item.image);
    const lines = [
      'Ab in die Kiste! 💋', 'Gute Wahl! 😏', 'Oh là là, eingepackt! ✨', 'Das wird ein Abend! 🔥'
    ];
    const ship = missing > 0
      ? `Noch <b>${money(missing)}</b> bis versandkostenfrei`
      : `<b>Versandkostenfrei geknackt!</b> 🎉`;
    toastEl = document.createElement('div');
    toastEl.className = 'hh-toast';
    toastEl.setAttribute('role', 'status');
    toastEl.setAttribute('aria-live', 'polite');
    toastEl.innerHTML =
      (img ? `<img class="hh-toast__img" src="${esc(img)}${img.includes('?') ? '&' : '?'}width=160" alt="">` : '<span></span>') +
      `<div class="hh-toast__k">${lines[Math.floor(Math.random() * lines.length)]}</div>` +
      `<button class="hh-toast__x" type="button" aria-label="Schließen">×</button>` +
      `<div class="hh-toast__t">${esc(item && (item.product_title || item.title))}</div>` +
      `<div class="hh-toast__ship">${ship}</div>` +
      `<div class="hh-toast__bar"><span></span></div>`;
    document.body.appendChild(toastEl);
    toastEl.querySelector('.hh-toast__x').addEventListener('click', () => hide());
    requestAnimationFrame(() => requestAnimationFrame(() => {
      toastEl.classList.add('is-in');
      toastEl.querySelector('.hh-toast__bar span').style.width = pct + '%';
    }));
    const hide = () => { if (!toastEl) return; const t = toastEl; t.classList.remove('is-in'); setTimeout(() => t.remove(), 600); toastEl = null; };
    toastTimer = setTimeout(hide, 5200);
    return missing === 0;
  };

  document.addEventListener('variant:add', (e) => {
    const src = e.target && e.target.querySelector ? (e.target.querySelector('[type="submit"]') || e.target) : null;
    let x = window.innerWidth / 2, y = window.innerHeight / 2;
    if (src && src.getBoundingClientRect) {
      const r = src.getBoundingClientRect();
      if (r.width) { x = r.left + r.width / 2; y = r.top + r.height / 2; }
      if (src.classList) { src.classList.add('hh-added'); setTimeout(() => src.classList.remove('hh-added'), 1400); }
    }
    const d = e.detail || {};
    const hasDrawer = !!document.getElementById('cart-drawer');
    const total = d.cart && typeof d.cart.total_price === 'number' ? d.cart.total_price : 0;
    const freeNow = hasDrawer ? total >= FREE_SHIPPING : toast(d.items && d.items[0], d.cart);
    burst(x, y, freeNow);
    bumpCart();
  });

  /* Versand-Countdown im Warenkorb nach jeder Änderung frisch vom Server holen */
  let refreshTimer = null;
  const refreshShip = () => {
    const boxes = [...document.querySelectorAll('.hh-ship')];
    if (!boxes.length) return;
    const ids = [...new Set(boxes.map((b) => { const s = b.closest('.shopify-section'); return s ? s.id.replace('shopify-section-', '') : null; }).filter(Boolean))];
    if (!ids.length) return;
    fetch(`${window.location.pathname}?sections=${ids.join(',')}`, { credentials: 'same-origin' })
      .then((r) => r.json())
      .then((json) => {
        ids.forEach((id) => {
          if (!json[id]) return;
          const doc = new DOMParser().parseFromString(json[id], 'text/html');
          const fresh = doc.querySelector('.hh-ship');
          const current = document.querySelector(`#shopify-section-${id} .hh-ship`);
          if (fresh && current) current.replaceWith(fresh);
        });
      }).catch(() => {});
  };
  document.addEventListener('cart:change', () => { clearTimeout(refreshTimer); refreshTimer = setTimeout(refreshShip, 250); });
  /* Diskret-Modus: Bilder verschwimmen, Tab heißt harmlos. Schalter unten links oder 2x Esc */
  const KEY = 'hh-discreet';
  const realTitle = document.title;
  let realIcon = null;
  const store = { get: () => { try { return localStorage.getItem(KEY) === '1'; } catch (e) { return false; } }, set: (v) => { try { localStorage.setItem(KEY, v ? '1' : '0'); } catch (e) {} } };
  const setIcon = (href) => {
    let l = document.querySelector('link[rel="shortcut icon"], link[rel="icon"]');
    if (!l) { l = document.createElement('link'); l.rel = 'icon'; document.head.appendChild(l); }
    if (realIcon === null) realIcon = l.href || '';
    l.href = href;
  };
  const applyDiscreet = (on) => {
    document.documentElement.classList.toggle('hh-discreet', on);
    document.title = on ? 'Einkaufsliste' : realTitle;
    if (on) setIcon("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Crect width='32' height='32' rx='6' fill='%234a90d9'/%3E%3Cpath d='M9 11h14M9 16h14M9 21h9' stroke='white' stroke-width='2.5' stroke-linecap='round'/%3E%3C/svg%3E");
    else if (realIcon !== null) setIcon(realIcon);
    const b = document.querySelector('.hh-discreet-btn');
    if (b) { b.setAttribute('aria-pressed', on ? 'true' : 'false'); b.querySelector('.hh-discreet-btn__label').textContent = on ? 'Diskret an' : 'Diskret-Modus'; }
  };
  const initDiscreet = () => {
    const b = document.createElement('button');
    b.type = 'button'; b.className = 'hh-discreet-btn';
    b.setAttribute('aria-label', 'Diskret-Modus: Produktbilder unscharf machen');
    b.title = 'Diskret-Modus (2x Esc)';
    b.innerHTML = '<span aria-hidden="true">🙈</span><span class="hh-discreet-btn__label">Diskret-Modus</span>';
    b.addEventListener('click', () => { const on = !document.documentElement.classList.contains('hh-discreet'); store.set(on); applyDiscreet(on); });
    document.body.appendChild(b);
    applyDiscreet(store.get());
    let lastEsc = 0;
    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      const now = Date.now();
      if (now - lastEsc < 450) { const on = !document.documentElement.classList.contains('hh-discreet'); store.set(on); applyDiscreet(on); lastEsc = 0; } else lastEsc = now;
    });
  };

  /* Augenzwinkern im Tab, wenn jemand weggeklickt hat */
  document.addEventListener('visibilitychange', () => {
    if (document.documentElement.classList.contains('hh-discreet')) return;
    document.title = document.hidden ? '💋 Komm zurück, wir warten …' : realTitle;
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initDiscreet); else initDiscreet();
})();
